export const BASE_URL = "https://ethtool.raininfotech.in";
// export const BASE_URL = "http://192.168.1.199:3001";
